import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TwitterService {
  share(isMobile: boolean, text: string, url: string, hashtags?: string, via?: string): void {
    let shareUrl = 'https://twitter.com/intent/tweet?';
    const params = new URLSearchParams({
      text: text,
      url: url,
    });

    if (hashtags) {
      params.set('hashtags', hashtags);
    }

    if (via) {
      params.set('via', via);
    }

    shareUrl += params.toString();

    if (isMobile) {
      navigator.clipboard.writeText(text).then(() => {
        window.open(shareUrl, '_blank');
      });
    } else {
      const width = 500;
      const height = 700;
      const left = window.screenX + (window.innerWidth - width) / 2;
      const top = window.screenY + (window.innerHeight - height) / 2;

      navigator.clipboard.writeText((text + url).trim()).then(() => {
        window.open(
          shareUrl,
          '_blank',
          `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`
        );
      });
    }
  }
}
